import './table-scrollable.css';
export default {
  "modifiers": {
    "borderRight": "pf-m-border-right",
    "borderLeft": "pf-m-border-left",
    "right": "pf-m-right",
    "inlineEnd": "pf-m-inline-end",
    "left": "pf-m-left",
    "inlineStart": "pf-m-inline-start"
  },
  "scrollInnerWrapper": "pf-v6-c-scroll-inner-wrapper",
  "scrollOuterWrapper": "pf-v6-c-scroll-outer-wrapper",
  "table": "pf-v6-c-table",
  "tableStickyCell": "pf-v6-c-table__sticky-cell"
};